import { render, staticRenderFns } from "./TicketCambioDeDireccion.vue?vue&type=template&id=207fb4cc&scoped=true&"
import script from "./TicketCambioDeDireccion.vue?vue&type=script&lang=js&"
export * from "./TicketCambioDeDireccion.vue?vue&type=script&lang=js&"
import style0 from "./TicketCambioDeDireccion.vue?vue&type=style&index=0&id=207fb4cc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fb4cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
